import React, { useCallback } from "react";
import { Checkbox } from "semantic-ui-react";
import styled from "styled-components";

const Holder = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1em;
`;

const Box = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid black;
`;

const SubBox = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    padding: 1em;
    &:not(:last-child) {
        border-bottom: 1px solid black; 
    }
`;

const Test6 = ({ setStpForm, view, id }) => {
    const onChange = useCallback((e, { name, checked }) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                if (item.STPTestView === view.STPTestView) {
                    item[name] = checked;
                }
            });

            return newStpForm;
        });
    }, [view]);

    return (
        <Holder id={id}>
            <Box>
                <SubBox>
                    Salt
                    <Checkbox style={{
                        position: 'absolute',
                        right: '-2em'
                    }}
                        name={`STPTest6_Salt`}
                        onChange={onChange}
                        checked={view.STPTest6_Salt}
                    />
                </SubBox>
                <SubBox>
                    Sugar
                    <Checkbox style={{
                        position: 'absolute',
                        right: '-2em'
                    }}
                        name={`STPTest6_Sugar`}
                        onChange={onChange}
                        checked={view.STPTest6_Sugar}
                    />
                </SubBox>
            </Box>
        </Holder>
    );
}

export default Test6;
